const DotGrid = () => {
  // Matriz 3x3: índices 0-8
  // Capas: [4] núcleo, [1,3,5,7] medio, [0,2,6,8] exterior
  const getLayer = (index) => {
    if (index === 4) return 0; // núcleo
    if ([1, 3, 5, 7].includes(index)) return 1; // medio
    return 2; // exterior
  };

  const dots = Array.from({ length: 9 }, (_, i) => ({
    id: i,
    layer: getLayer(i),
    row: Math.floor(i / 3),
    col: i % 3
  }));

  return (
    <>
      <style>{`
        @keyframes heartbeat {
          0% {
            transform: scale(1);
            opacity: 0.15;
          }
          /* Aparición lenta desde el centro */
          25% {
            transform: scale(var(--scale-target));
            opacity: var(--opacity-target);
          }
          /* Sosten en plenitud */
          60% {
            transform: scale(var(--scale-target));
            opacity: var(--opacity-target);
          }
          /* Desaparición rápida */
          68% {
            transform: scale(1);
            opacity: 0.15;
          }
          /* Pausa de vacío */
          100% {
            transform: scale(1);
            opacity: 0.15;
          }
        }

        .dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: white;
          animation: heartbeat 2s infinite;
        }

        .layer-0 {
          --scale-target: 1.4;
          --opacity-target: 0.9;
          animation-delay: 0s;
        }

        .layer-1 {
          --scale-target: 1.3;
          --opacity-target: 0.85;
          animation-delay: 0.15s;
        }

        .layer-2 {
          --scale-target: 1.25;
          --opacity-target: 0.8;
          animation-delay: 0.25s;
        }
      `}</style>

      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '5px',
          alignItems: 'center'
        }}
      >
        {[0, 1, 2].map((row) => (
          <div 
            key={row} 
            style={{ 
              display: 'flex', 
              gap: '5px' 
            }}
          >
            {dots
              .filter((d) => d.row === row)
              .map((dot) => (
                <div
                  key={dot.id}
                  className={`dot layer-${dot.layer}`}
                />
              ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default DotGrid;